import { getOssUploadUrl } from '@/api/api'

export const mixin = {
    methods:{
        // 上传地址
        uploadImageUrl(){
            return this.$store.state.configure.HOST + "/common/uploadImg"
        },
        uploadAvatarUrl(){
            return this.$store.state.configure.HOST + "/user/setUserAvatar"
        },
        uploadFileUrl(){
            return this.$store.state.configure.HOST + "/common/uploadFile"
        },
        uploadVideoUrl(){
            return this.$store.state.configure.HOST + "/common/uploadVideo"
        },
        // 文件超出个数限制时的钩子
        handleExceed(files, fileList) {
            this.$message.warning(`本次选择了 ${files.length} 个文件，文件上传限制为9个`);
        },
        //上传图片之前的校验
        beforeAvatorUpload(file){
            const isLt20M = (file.size / 1024 /1024) < 20;
            if(!isLt20M){
                this.$message.error('上传图片单张大小不能超过20MB');
                return false;
            }
            return true;
        },
        // 重置表单
        resetForm(refName) {
            if (this.$refs[refName]) {
                this.$refs[refName].resetFields()
            }
        },
        // 获取 OSS 文件访问 URL（用于 img src 绑定，重定向到 Presigned URL）
        getOssFileUrl(path) {
          if (!path) return ''
          return this.$store.state.configure.HOST + '/common/ossFile?path=' + encodeURIComponent(path)
        },
        // 获取 OSS 视频播放 URL
        getOssVideoUrl(path) {
          if (!path) return ''
          return this.$store.state.configure.HOST + '/common/ossFile?path=' + encodeURIComponent(path)
        },
        // OSS 直传：获取签名 URL 后直接上传到 OSS，不经过应用服务器
        // 可传 { domain, domainId } 使用新目录结构，如 { domain: 'course', domainId: 'xxx' }
        ossDirectUpload(file, type, { domain, domainId, onProgress } = {}) {
            return new Promise((resolve, reject) => {
                getOssUploadUrl({ fileName: file.name, type: type, domain, domainId }).then(res => {
                    if (res.code !== 1000) {
                        reject(new Error(res.message || '获取上传链接失败'))
                        return
                    }
                    const { uploadUrl, objectKey } = res.data
                    const reader = new FileReader()
                    reader.onload = function (e) {
                        const xhr = new XMLHttpRequest()
                        xhr.open('PUT', uploadUrl, true)
                        if (onProgress) {
                            xhr.upload.onprogress = function (e) {
                                if (e.lengthComputable) {
                                    onProgress({ percent: Math.round((e.loaded / e.total) * 100) })
                                }
                            }
                        }
                        xhr.onload = function () {
                            if (xhr.status >= 200 && xhr.status < 300) {
                                resolve({ objectKey, fileName: file.name })
                            } else {
                                reject(new Error('上传到OSS失败'))
                            }
                        }
                        xhr.onerror = function () {
                            reject(new Error('上传到OSS失败'))
                        }
                        xhr.send(e.target.result)
                    }
                    reader.onerror = function () {
                        reject(new Error('读取文件失败'))
                    }
                    reader.readAsArrayBuffer(file)
                }).catch(() => {
                    reject(new Error('获取上传链接失败'))
                })
            })
        },
    }
}


